
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import Logo from '../assets/logo.png'
import {
  MenuIcon,
  XIcon,
} from '@heroicons/react/outline'

export const Header = ({aboutUs, rules, features,tryGame}) => {

  return (
    <Popover className="relative ">
      {({ open }) => (
        <>
          <div className="flex justify-between items-center px-4 py-6 head sm:px-6 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <a href="#">
                <span className="sr-only">Workflow</span>
                <img
                  className="h-10 w-auto sm:h-10 rounded-xl"
                  src={Logo}
                  alt=""
                />
              </a>
            </div>
            <div className="-mr-2 -my-2 md:hidden">
              <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500">
                <span className="sr-only">Open menu</span>
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </Popover.Button>
            </div>
            <Popover.Group as="nav" className="hidden md:flex space-x-10">
              <Popover className="relative">
                {({ open }) => (
                  <>
                    

                    <Transition
                      show={open}
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel
                        static
                        className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                      >
                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                          
                          <div className="p-5 bg-gray-50 sm:p-8">
                            <a href="#" className="-m-3 p-3 flow-root rounded-md hover:bg-gray-100">
                              <div className="flex items-center">
                                <div className="text-base font-medium text-gray-900">Enterprise</div>
                                <span className="ml-3 inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium leading-5 bg-indigo-100 text-indigo-800">
                                  New
                                </span>
                              </div>
                              <p className="mt-1 text-sm text-gray-500">
                                Empower your entire team with even more advanced tools.
                              </p>
                            </a>
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>

              <a onClick={() => aboutUs.current.scrollIntoView({ behavior: "smooth" })}   className="text-base header-link text-gray-500 hover:text-gray-900">
                About Us

              </a>
              <a onClick={() => rules.current.scrollIntoView({ behavior: "smooth" })} className="text-base header-link font-medium text-gray-500 hover:text-gray-900">
                Rules
              </a>
              <a  onClick={() => features.current.scrollIntoView({ behavior: "smooth" })} className="text-base header-link font-medium text-gray-500 hover:text-gray-900">
               Features
              </a>

            </Popover.Group>
            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
              <a
                onClick={() => tryGame.current.scrollIntoView({ behavior: "smooth" })}
                className="ml-8 whitespace-nowrap font-bold bounce-hover inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white theme"
              >
                Try Demo Now
              </a>
            </div>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              static
              className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
            >
              <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 popup dropdown bg-white  divide-y-2 divide-gray-50">
                <div className="pt-5 pb-6 px-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <img
                        className="h-9 w-auto rounded-md"
                        src={Logo}
                        alt="Workflow"
                      />
                    </div>
                    <div className="-mr-2">
                      <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500">
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </Popover.Button>
                    </div>
                  </div>
                </div>
                <div className="py-6 px-5 ">
                  <div className="flex-col flex justify-center ">
                    <a onClick={() => aboutUs.current.scrollIntoView({ behavior: "smooth" })} className="text-base self-center mb-5 font-medium text-gray-900 hover:text-gray-700">
                      <Popover.Button>
                        About Us
                      </Popover.Button>
                    </a>

                    <a onClick={() => rules.current.scrollIntoView({ behavior: "smooth" })} className="text-base self-center mb-5 font-medium text-gray-900 hover:text-gray-700">
                      <Popover.Button>
                        Rules
                      </Popover.Button>
                    </a>

                    <a onClick={() => features.current.scrollIntoView({ behavior: "smooth" })} className="text-base self-center font-medium text-gray-900 hover:text-gray-700">
                      <Popover.Button>
                        Features
                      </Popover.Button>
                    </a>
                    
                  </div>
                  <div className="mt-6">
                    <a
                        onClick={() => tryGame.current.scrollIntoView({ behavior: "smooth" })}
                      className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white theme"
                    >
                      <Popover.Button>
                        Try Demo Now
                      </Popover.Button>
                    </a>

                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  )
}
